<template>
  
  <div>
    <b-form inline>
      <label>Lees OID</label>
      <b-input class="mr-2 ml-1" placeholder=".1.3.6" v-model="oid" style="width: 24em" />

      <busy-btn :busy="busy" variant="primary" @click="click">Uitvoeren</busy-btn>
      <span v-if="timedOut" class="ml-2">Timeout</span>
    </b-form>

    <div class="mt-3">
      <b-textarea rows="15" :value="result" class="text-monospace" />
    </div>


  </div>
  
</template>

<script>

import BusyBtn from '@/components/BusyBtn';

export default
{
    components: { BusyBtn },
    data()
    {
        return {
            busy: false,
            timedOut: false,
            oid: '.1.3.6',
            result: ''
        }
    },
    methods:
    {
        async click()
        {
            this.busy = true;
            this.timedOut = false;
            this.result = '';

            const obs = this.$apollo.subscribe(
                {
                    query: require('../graphql/live/oid_test.gql'),
                    variables:
                    {
                        printerId: this.printerId,
                        oid: this.oid
                    }
                }
            );

            let timeout, sub;
            const self = this;

            function cleanup()
            {
                if(timeout) clearTimeout(timeout);
                if(sub) sub.unsubscribe();

                self.busy = false;
            }

            sub = obs.subscribe(
                {
                    next({data})
                    {
                        self.result = JSON.stringify(data.readOid.text, null, 2);
                        cleanup();
                    },
                    error(errorValue)
                    {
                        console.error(errorValue);
                        cleanup();
                    }
                }
            );

            timeout = setTimeout(() => { this.timedOut = true; cleanup(); }, 10000);
        }
    },
    props:
    {
        printerId: { }
    }
}
</script>

<style>
</style>